/** Stable Firestore ids written by `npm run seed:firestore` (Admin SDK). */
export const DEMO_ECOSYSTEM_USER_IDS = [
  'erudis_demo_prof_rivera',
  'erudis_demo_prof_chen',
  'erudis_demo_prof_bell',
  'erudis_demo_phd_kim',
  'erudis_demo_phd_santos',
  'erudis_demo_postdoc_lee',
  'erudis_demo_researcher_walsh',
  'erudis_demo_sci_patel',
] as const;

export const DEMO_ECOSYSTEM_LAB_IDS = [
  'erudis_demo_lab_mit_rivera',
  'erudis_demo_lab_stanford_chen',
  'erudis_demo_lab_berkeley_bell',
] as const;

export const DEMO_ECOSYSTEM_POST_IDS = [
  'erudis_demo_post_01',
  'erudis_demo_post_02',
  'erudis_demo_post_03',
  'erudis_demo_post_04',
  'erudis_demo_post_05',
  'erudis_demo_post_06',
  'erudis_demo_post_07',
  'erudis_demo_post_08',
  'erudis_demo_post_09',
  'erudis_demo_post_10',
  'erudis_demo_post_11',
  'erudis_demo_post_12',
] as const;
